export const error = () => ({
  width: '100%',
})
